// extracted by mini-css-extract-plugin
export default {"outerDiv":"sec-card_outerDiv__K6f4Z"};